import { Badge, BadgeProps, RewriteMdIcon } from '@crono-one/design-system';

const AiStarsBadge = ({ size = 'md', ...props }: BadgeProps) => (
  <Badge
    tone="purple"
    size={size}
    shape="rounded"
    startIcon={RewriteMdIcon}
    {...props}
  >
    AI
  </Badge>
);

export default AiStarsBadge;
